import useFetch from '../hooks/useFetch';

const getPeriodos = async () => {
  try {
    return await useFetch.fnPost('planVacaciones/getPeriodos', {});
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const guardarPeriodo = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/guardarPeriodo', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getPlanEmpleado = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/getPlanEmpleado', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const guardarDias = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/guardarDias', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const enviarPlan = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/enviarPlan', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getPlanes = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/getPlanes', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getPanelPlanVacacion = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/getPanelPlanVacacion', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getReporteDepartamento = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/getReporteDepartamento', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const aprobarPlan = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/aprobarPlan', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const rechazarPlan = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/rechazarPlan', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const aplicarPlan = async (dataRequest) => {
  try {
    return await useFetch.fnPost('planVacaciones/aplicarPlan', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

export default {
  getPeriodos,
  guardarPeriodo,
  getPlanEmpleado,
  guardarDias,
  enviarPlan,
  getPlanes,
  getPanelPlanVacacion,
  getReporteDepartamento,
  aprobarPlan,
  rechazarPlan,
  aplicarPlan,
};
